import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import {
  ABOUT_COMPANY_GENERAL_NAMES,
  prefix as aboutCompanyGeneralPrefix,
} from 'components/BusinessToolForm/Sections/AboutCompany/GeneralInfo/utils/form';
import {
  ABOUT_COMPANY_MISSION_NAMES,
  prefix as companyMissionPrefix,
} from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import {
  EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES,
  prefix as executiveSummaryFinancialInfoPrefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialInformationExecSummary/utils/form';
import {
  EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES,
  prefix as financingNeedsPrefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';
import {
  EXECUTIVE_SUMMARY_MARKET_NAMES,
  prefix as executiveSummaryMarketPrefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import {
  prefix as execSummaryTeamPrefix,
  EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/TeamExecSummary/utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';
import {
  IMPLEMENTATION_PLAN_NAMES,
  prefix as ImplementationPlanPrefix,
} from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';
import {
  MANAGEMENT_TEAM_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';
import {
  COMPANY_OVERVIEW_NAMES,
  prefix as overviewCompanyPrefix,
} from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import {
  COMPANY_PROJECT_NAMES,
  prefix as projectOverviewPrefix,
} from 'components/BusinessToolForm/Sections/Overview/ProjectOverview/utils/form';

import { concatWithDot } from 'helpers/string';

export const aboutCompanyFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPANY_NAME),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.REGISTRATION_DATE),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.ADDRESS),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPANY_SECTOR),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.ANNUAL_INCOME),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION),
  concatWithDot(overviewCompanyPrefix, COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.PHONE),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.EMAIL),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME),
  concatWithDot(aboutCompanyGeneralPrefix, ABOUT_COMPANY_GENERAL_NAMES.POSITION),
];

export const aboutProjectFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_GOALS),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION),
  concatWithDot(projectOverviewPrefix, COMPANY_PROJECT_NAMES.STATUS),
  concatWithDot(companyMissionPrefix, ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET),
  concatWithDot(companyMissionPrefix, ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM),
];

export const productsAndServicesFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE),
];

export const marketAndSalesFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.REVENUE_STREAMS),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MARKETING_STRATEGY),
  concatWithDot(executiveSummaryMarketPrefix, EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS),
];

export const teamFieldsToCheckNames = [
  concatWithDot(execSummaryTeamPrefix, EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS),
  concatWithDot(prefix, MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES),
];

export const financialProjectionFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD),
  concatWithDot(executiveSummaryFinancialInfoPrefix, EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.PROJECTED_ANNUAL_PROFIT),
  concatWithDot(executiveSummaryFinancialInfoPrefix, EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.RETURN_ON_INVESTMENT),
  concatWithDot(executiveSummaryFinancialInfoPrefix, EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.INTERNAL_RATE_OF_RETURN),
];

export const financialNeedsFieldsToCheckNames = [
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TOTAL_COST),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FUNDING_AMOUNT),
  concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST),
  concatWithDot(financingNeedsPrefix, EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST),
];

export const implementationPlanFieldsToCheck = [
  concatWithDot(ImplementationPlanPrefix, IMPLEMENTATION_PLAN_NAMES.STAGES , "[0].from"),
  concatWithDot(ImplementationPlanPrefix, IMPLEMENTATION_PLAN_NAMES.STAGES , "[0].to"),
  concatWithDot(ImplementationPlanPrefix, IMPLEMENTATION_PLAN_NAMES.STAGES , "[0].stage"),
];

export const onePageSectionsMap = {
  [ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY]: aboutCompanyFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT]: aboutProjectFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.PRODUCTS_SERVICES]: productsAndServicesFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.MARKET_AND_SALES]: marketAndSalesFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.TEAM]: teamFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS]: financialProjectionFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.FINANCING_NEEDS]: financialNeedsFieldsToCheckNames,
  [ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN]: implementationPlanFieldsToCheck,
};
